// Parse the displayed starting price without changing the content of the price card.
export function parseTrackingPrice(text) {
  if (typeof text !== 'string') return {price: null, currency: null};
  const match = text.trim().match(/^(?:(?:od|from)\s+)?(\d+(?:[.,]\d{1,2})?)\s*(zł|pln|eur|usd|gbp|huf|ron|czk)\s*$/i);
  if (!match) return {price: null, currency: null};
  return {
    price: Number(match[1].replace(',', '.')),
    currency: match[2].toLowerCase() === 'zł' ? 'PLN' : match[2].toUpperCase(),
  };
}
